<template>
  <div>
    <md-card id="reports" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">assignment_ind</i>
        </div>
        <h4 class="title">Generated Reports</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="currentSearchTxt" @keyup.enter="handleSearch" />
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Date</label>
              <md-select v-model="currentFilterDate" name="currentFilterDate">
                <md-option v-for="(type, index) in filterDateOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Status</label>
              <md-select v-model="currentFilterStatus" name="currentFilterStatus">
                <md-option v-for="(type, index) in filterStatusOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Downloaded</label>
              <md-select v-model="currentFilterDownloaded" name="currentFilterDownloaded">
                <md-option v-for="(type, index) in filterDownloadedOptions" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div v-if="organizations.length > 2" class="md-layout-item md-size-15">
            <md-field>
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <!-- <div class="md-layout-item md-size-10">
            <drop-down direction="down">
              <md-button slot="title" class="md-button md-primary md-sm md-block dropdown-toggle"
                data-toggle="dropdown">Sort</md-button>

              <ul class="dropdown-menu dropdown-menu-right">
                <li style="margin-left: 20px;" @click="labelSort('last', true)">By Last Name</li>
                <li style="margin-left: 20px;" @click="labelSort('first', true)">By First Name</li>
                <li style="margin-left: 20px;" @click="labelSort('globe', true)">Globe</li>
                <li style="margin-left: 20px;" @click="labelSort('created', true)">Date</li>
                <li style="margin-left: 20px;" @click="labelSort('reader', true)">Status</li>
              </ul>                       
            </drop-down>
          </div> -->

          <div class="md-layout-item" :class="[
            { 'md-size-20': organizations.length > 2 },
            { 'md-size-35': organizations.length <= 2 }
          ]" style="align-items: end">
            <!-- <drop-down direction="down">
              <md-button slot="title" class="md-button md-primary md-sm md-block dropdown-toggle" data-toggle="dropdown"
                >Filter</md-button
              >

              <ul class="dropdown-menu dropdown-menu-right">
                <li v-for="item in filterItems" :key="item.id" style="margin-left: 20px" @click="selectFilter(item)">
                  {{ item.name }}
                </li>
              </ul>
            </drop-down> -->
            <div class="md-layout md-gutter md-layout-item"
              style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter reports</md-tooltip>
              </md-button>
              <md-button :disabled="!reportsSelected.length || isDownloading" class="md-icon-button md-primary"
                @click="handleDownload">
                <md-icon>download</md-icon>
                <md-tooltip md-direction="bottom">Download selected reports ({{ reportsSelected.length }})</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
        <!-- <hr  /> -->
        <div style="padding: 0rem" v-if="isPreparing || isDownloading">
          <div style="display: flex; align-items: center; justify-content: center; flex-direction: column"
            v-if="isDownloading && !isPreparing">
            <div style="margin-bottom: 0.5rem">Downloading reports...</div>
            <v-progress-circular :rotate="360" :size="100" :width="15" :value="downloadProgress" color="#43a047">
              {{ downloadProgress }}%
            </v-progress-circular>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <div v-if="!isLoading && tableData.length" style="
            position: absolute;
            margin-top: 0.7rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 30px;
          ">
          <md-checkbox id="select-all" v-model="allSelected" @change="toggleAllSelected($event)" />
        </div>
        <md-table v-if="!isLoading" id="reports-table" v-model="tableData"
          class="table-shopping table-striped table-hover" @click.native="labelSort($event, false)">
          <md-table-row>
            <md-table-empty-state :md-description="`No reports found for this time frame or search criteria`"
              md-label="No reports found" />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }"
            :class="{ isEDIT: item.mode.toLowerCase() === 'edit' }" @click="gotoReport(item)">
            <md-table-cell style="height: 55px; width: 26px" />
            <md-table-cell md-label="" style="height: 55px; width: 46px">
              <md-checkbox :id="item.report_id" :value="item.report_id" v-model="reportsSelected"
                @change="verifyAllSelected()" />
            </md-table-cell>
            <md-table-cell md-label="Date" style="font-size: 0.88em; font-weight: 500">
              <span>{{ formattedDate(item) }}</span> <br />
              <small style="font-size: 0.87em; color: darkgreen">
                {{ item.packageID.slice(0, 11).toUpperCase() }}</small>
            </md-table-cell>

            <md-table-cell md-label="Name" style="font-size: 1.13em">{{ item.mbr_firstName }} {{ item.mbr_lastName
            }}</md-table-cell>
            <md-table-cell md-label="Email" style="font-size: 0.95em; color: blue">{{ item.mbr_Email }}</md-table-cell>
            <md-table-cell md-label="Disposition">{{ item.mode }}</md-table-cell>
            <md-table-cell md-label="Globe"><small>{{ item.kiosk_id }}</small>
            </md-table-cell>

            <md-table-cell md-label="Reader">{{ item.genBy }}</md-table-cell>
            <md-table-cell md-label="Status"><small :class="{ isRead: itemRead(item) }">{{ item.status
            }}</small></md-table-cell>

            <md-table-cell md-label="Downloaded">
              <small>{{ item.isDownloaded ? "Yes" : "No" }}</small>
            </md-table-cell>

            <md-table-cell>
              <div style="display: flex; justify-content: space-between">
                <md-button :disabled="item.mode.toLowerCase() === 'edit'"
                  :class="{ 'md-grey': item.mode.toLowerCase() === 'edit' }" style="width: 35px; margin: 0px"
                  @click.stop="handleEdit(item)">
                  <md-icon style="
                      margin-left: 0px !important;
                      margin-right: 30px !important;
                      padding-bottom: 8px;
                      padding-right: 5px;
                    ">edit</md-icon>
                  <md-tooltip md-direction="bottom">EDIT in On-Hold queue</md-tooltip>
                </md-button>

                <md-button v-if="showRX" :disabled="rxModalOpen && item == selectedRx"
                  :class="{ 'md-grey': rxModalOpen && item == selectedRx }" style="width: 35px; margin: 0px 0px 0px 5px"
                  @click.stop="handleRxClick(item)">
                  <md-icon style="
                      margin-left: 0px !important;
                      margin-right: 30px !important;
                      padding-bottom: 8px;
                      padding-right: 5px;
                    ">preview</md-icon>
                  <md-tooltip md-direction="bottom">Open RX modal</md-tooltip>
                </md-button>

              </div>
            </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading" />
        <div v-if="!isLoading" style="display: flex; align-items: center">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left" />
            </a>
            <span class="page-link"
              style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px">{{ currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right" />
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content: center; align-items: start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from
                <b><u>{{ startReport }}</u></b>
                to
                <b><u>{{ endReport }}</u></b>. Total of
                <b><u>{{ totalReports }}</u></b>
                reports.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading || isPreparing" />
    <modal v-if="rxModalOpen" style="overflow: auto; height: 83vh"
      m-header="modal-header modal-no-padding modal-no-margin" m-body="modal-body modal-no-padding modal-no-margin"
      m-footer="modal-footer modal-no-padding modal-no-margin" @close="handleRxModalClose('rxModal')">
      <template slot="body">
        <prescription-info :m-screening="selectedRx.packageID" :m-patient="selectedRx.mbr_Email" :m-rx="rxValues"
          :no-margins="true" prescription-type="glasses" @openRxPreview="handleRxPreview($event, 'glasses')"
          @close="handleRxModalClose" />
        <prescription-info :m-screening="selectedRx.packageID" :m-patient="selectedRx.mbr_Email" :m-rx="rxValues"
          :no-margins="true" prescription-type="contact" @openRxPreview="handleRxPreview($event, 'contact')" />
      </template>
    </modal>
    <!-- MODAL Rx-REPORT PREVIEW     md-dynamic-height -->
    <modal v-if="rxRptPreview" style="overflow: auto; height: 83vh" m-container="modal-container-report">
      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <rx-report-preview id="pdfreport" :rx-values="rxValues" @onCloseRX="handleRxModalClose('rxPreview')"
              :title="`GLASSES`" :showNoRefraction="false" />
          </div>
        </div>
      </template>
    </modal>

    <modal v-if="rxLensRptPreview" style="overflow: auto; height: 83vh" m-container="modal-container-report">
      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <rx-report-preview id="pdfreport" :rx-values="rxValues" @onCloseRX="handleRxModalClose('rxPreview')"
              :title="`CONTACT`" :showNoRefraction="false" />
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"
import InfoRxPrescription from "@/components/GlobeChek/screening/info-rx-prescription"
import { Modal } from "@/components"
import RxReportPreview from "@/components/GlobeChek/screening/eval-rxreport-preview"
import { mapActions } from "vuex"

export default {
  components: {
    loader,
    "prescription-info": InfoRxPrescription,
    "rx-report-preview": RxReportPreview,
    Modal
  },
  data() {
    return {
      rxRptPreview: false,
      rxLensRptPreview: false,
      rxValues: {
        odSPH: null,
        odCYL: null,
        odAXS: null,
        odPOW: null,
        odDIS: null,
        odBC: null,
        odDIA: null,
        odCOL: null,
        odBRA: null,
        odMAN: null,
        odQT: null,
        osSPH: null,
        osCYL: null,
        osAXS: null,
        osPOW: null,
        osDIS: null,
        osBC: null,
        osDIA: null,
        osCOL: null,
        osBRA: null,
        osMAN: null,
        osQT: null,
        ouCOM: null
      },
      rxModalOpen: false,
      selectedRx: null,
      API_SERVICE: process.env.VUE_APP_URL,
      API_ROUTE: "/reports/@val/" + sessionStorage.getItem("username"),
      API_MODE: "a",
      allReports: [],
      filteredReports: [],
      tableData: [],
      reportsSelected: [],
      allSelected: false,
      currentSort: "name",
      currentSortOrder: "asc",
      orderAsc: false,
      searchQuery: "",
      fuseSearch: null,
      offset: 0,
      limit: 50,
      totalReports: 0,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      isLoading: false,
      isDownloading: false,
      isPreparing: false,
      downloadProgress: 0,
      dots: '',
      dotInterval: null,
      filterDownloadedOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "Yes",
          value: "yes"
        },
        {
          label: "No",
          value: "no"
        }
      ],
      filterStatusOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "Read",
          value: "read"
        },
        {
          label: "Unread",
          value: "unread"
        }
      ],
      filterDateOptions: [
        {
          label: "All",
          value: "all"
        },
        {
          label: "Past day",
          value: "pastDay"
        },
        {
          label: "Past week",
          value: "pastWeek"
        },
        {
          label: "Past month",
          value: "pastMonth"
        },
        {
          label: "Past 3 months",
          value: "past3Months"
        },
        {
          label: "Past 6 months",
          value: "past6Months"
        },
        {
          label: "Past year",
          value: "pastYear"
        }
      ],
      currentOrganization: JSON.parse(sessionStorage.getItem("organizations")).length === 1 ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId : (localStorage.getItem("currentOrgSelectedForFilters") || "all"),
      organizations: [
        { label: "All", value: "all" },
        ...JSON.parse(sessionStorage.getItem("organizations")).map((i) => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        })
      ],
      currentSearchTxt: "",
      currentFilterDate: "pastWeek",
      currentFilterDownloaded: "all",
      currentFilterStatus: "all"
    }
  },
  computed: {
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.filteredReports.length
    },
    startReport() {
      return this.offset + 1
    },
    endReport() {
      return Math.min(this.offset + this.limit, this.filteredReports.length) || 1
    },
    showRX() {
      const userTypeRaw = sessionStorage.getItem("usertype")
      const userType = userTypeRaw ? userTypeRaw.toLowerCase() : ''
      return ['reader', 'technician'].includes(userType)
    }
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit
      this.offset = 0
      this.sliceReports()
    },
    isPreparing(newVal) {
      if (newVal) {
        this.startDotAnimation();
      } else {
        this.stopDotAnimation();
      }
    }
  },

  methods: {
    ...mapActions(["generatePdfReport"]),
    setReadingDoctor() {
      let fn = sessionStorage.getItem("firstname")
      let ln = sessionStorage.getItem("lastname")
      let readingDoctor = fn + " " + ln + " " + "MD"
      sessionStorage.setItem("ReadingDoctor", readingDoctor)
    },
    handleRxPreview(rxValues, type) {
      this.rxValues = rxValues
      this.rxModalOpen = false

      if (type == "glasses") {
        this.rxRptPreview = true
      } else {
        this.rxLensRptPreview = true
      }
    },
    handleRxModalClose(modal) {
      switch (modal) {
        case "rxModal":
        default:
          this.rxModalOpen = false
          this.selectedRx = null
          this.rxValues = {
            odSPH: null,
            odCYL: null,
            odAXS: null,
            odPOW: null,
            odDIS: null,
            odBC: null,
            odDIA: null,
            odCOL: null,
            odBRA: null,
            odMAN: null,
            odQT: null,
            osSPH: null,
            osCYL: null,
            osAXS: null,
            osPOW: null,
            osDIS: null,
            osBC: null,
            osDIA: null,
            osCOL: null,
            osBRA: null,
            osMAN: null,
            osQT: null,
            ouCOM: null
          }
          break
        case "rxPreview":
          this.rxRptPreview = false
          this.rxLensRptPreview = false
          this.rxModalOpen = true
          break
      }
    },
    updateRx(updatedRx) {
      this.rxValues = updatedRx
    },
    async handleRxClick(item) {
      this.selectedRx = item
      sessionStorage.setItem("storageID", item.packageID)
      this.setReadingDoctor()
      sessionStorage.setItem("OrgBusiness", item.orgBusiness)
      this.$store.dispatch("updateScreeningDateEval", item.screeningDate)
      this.$store.dispatch("updateScreeningDobEval", item.DOB)

      this.$store.dispatch("updateScreeningPatientInfo", {
        firstName: item.mbr_firstName,
        lastName: item.mbr_lastName,
        phone: item.patientPhone,
        email: item.mbr_Email,
        address: {
          addressLn1: item.address1,
          addressLn2: item.address2,
          city: item.city,
          state: item.state,
          zip: item.zipCode
        }
      })
      this.rxModalOpen = true
    },
    toggleAllSelected($event) {
      if (Array.isArray($event)) {
        if ($event.length === 1) {
          this.allSelected = true
        } else {
          this.selected = false
        }
      } else {
        this.allSelected = $event
      }
      this.reportsSelected = []
      if (this.allSelected) {
        for (const i of this.filteredReports) {
          this.reportsSelected.push(i.report_id)
        }
      }
    },
    verifyAllSelected() {
      this.allSelected = this.filteredReports.length === this.reportsSelected.length
    },
    async fetchReports() {
      this.isLoading = true
      const url = (this.API_SERVICE + this.API_ROUTE).replace("@val", this.API_MODE)
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null

      window.axios
        .get(url, data, config)
        .then((r) => r.data)
        .then((reports) => {
          // remove duplicated reports
          const reportMap = new Map()
          reports.forEach((report) => {
            const { packageID, updatedAt } = report
            if (!reportMap.has(packageID) || new Date(updatedAt) > new Date(reportMap.get(packageID).updatedAt)) {
              reportMap.set(packageID, report)
            }
          })
          this.allReports = Array.from(reportMap.values())
          this.handleSearch()
        })
        .catch(function (error) {
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sliceReports() {
      this.tableData = JSON.parse(JSON.stringify(this.filteredReports)).slice(this.offset, this.offset + this.limit)
    },
    updateLimit(newLimit) {
      this.offset = 0
      this.sliceReports()
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.sliceReports()
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.sliceReports()
      }
    },
    itemRead(item) {
      return item.status == "read"
    },
    formattedDate(item) {
      return new moment(item.updatedAt).format("MM/DD/YYYY")
    },
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.orderAsc = !this.orderAsc
      switch (sort) {
        case "first":
          this.screensByFirstfirst(this.orderAsc)
          break

        case "last":
          this.screensByLastfirst(this.orderAsc)
          break

        case "email":
          this.screensByEmail(this.orderAsc)
          break

        case "reader":
          this.screensByReader(this.orderAsc)
          break

        case "created":
          this.screensByCreated(this.orderAsc)
          break

        case "globe":
          this.screensByGlobe(this.orderAsc)
          break

        default:
          return null
      }
    },
    screensByLastfirst(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return a.last_name > b.last_name ? 1 : -1
        } else {
          return a.last_name < b.last_name ? 1 : -1
        }
      })
      this.tableData = newReports
    },
    screensByFirstfirst(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return a.first_name > b.first_name ? 1 : -1
        } else {
          return a.first_name < b.first_name ? 1 : -1
        }
      })
      this.tableData = newReports
    },
    screensByCreated(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return new moment(a.created_at.split(" ")[0]).format("YYYYMMDD") >
            new moment(b.created_at.split(" ")[0]).format("YYYYMMDD")
            ? 1
            : -1
        } else {
          return new moment(a.created_at.split(" ")[0]).format("YYYYMMDD") <
            new moment(b.created_at.split(" ")[0]).format("YYYYMMDD")
            ? 1
            : -1
        }
      })
      this.tableData = newReports
    },
    screensByReader(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return a.created_by > b.created_by ? 1 : -1
        } else {
          return a.created_by < b.created_by ? 1 : -1
        }
      })
      this.tableData = newReports
    },
    screensByTechnician(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return a.technician > b.technician ? 1 : -1
        } else {
          return a.technician < b.technician ? 1 : -1
        }
      })
      this.tableData = newReports
    },
    screensByGlobe(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return a.kiosk_id > b.kiosk_id ? 1 : -1
        } else {
          return a.kiosk_id < b.kiosk_id ? 1 : -1
        }
      })
      this.tableData = newReports
    },
    screensByEmail(order) {
      let newReports = this.filteredReports.slice().sort(function (a, b) {
        if (order) {
          return a.email.toLowerCase() > b.email.toLowerCase() ? 1 : -1
        } else {
          return a.email.toLowerCase() < b.email.toLowerCase() ? 1 : -1
        }
      })
      this.tableData = newReports
    },
    handleSearch() {
      this.reportsSelected = []
      this.allSelected = []
      const searchFilter = this.currentSearchTxt
      const dateFilter = this.currentFilterDate
      const isDownloadedFilter = this.currentFilterDownloaded
      const orgFilter = this.currentOrganization
      localStorage.setItem("currentOrgSelectedForFilters", orgFilter)
      const statusFilter = this.currentFilterStatus

      let response = JSON.parse(JSON.stringify(this.allReports))
      if (searchFilter) {
        response = response.filter((i) => {
          const searchText = (
            (i.mbr_firstName || "") +
            " " +
            (i.mbr_lastName || "") +
            (i.mbr_Email || "") +
            (i.reader || "") +
            (i.readerID || "") +
            (i.genBy || "") +
            (i.kiosk_id || "")
          ).toLowerCase()
          return searchText.includes(searchFilter.toLowerCase())
        })
      }
      if (orgFilter != "all") {
        response = response.filter((i) => i.orgID === orgFilter)
      }
      if (dateFilter != "all") {
        const filters = {
          pastDay: moment(new Date()).subtract(1, "day").toDate().toISOString(),
          pastWeek: moment(new Date()).subtract(7, "days").toDate().toISOString(),
          pastMonth: moment(new Date()).subtract(1, "month").toDate().toISOString(),
          past3Months: moment(new Date()).subtract(3, "months").toDate().toISOString(),
          past6Months: moment(new Date()).subtract(6, "months").toDate().toISOString(),
          pastYear: moment(new Date()).subtract(1, "year").toDate().toISOString()
        }
        response = response.filter((i) => i.updatedAt >= filters[dateFilter])
      }
      if (isDownloadedFilter != "all") {
        const value = isDownloadedFilter === "yes"
        response = response.filter((i) => i.isDownloaded == value)
      }
      if (statusFilter != "all") {
        response = response.filter((i) => i.status === statusFilter)
      }
      this.filteredReports = response
      this.totalReports = response.length
      this.offset = 0
      this.sliceReports()
    },
    filterSelect(item) {
      this.selectedFilter = item.id
      this.payload.filter = item.val
      this.$store.dispatch("loadScreenings", this.payload)
      this.tableData = this.screenings
    },
    getSelected(items) {
      this.reportsSelected = this.tableData.slice()
    },
    gotoReport(item) {
      this.selected = item
      sessionStorage.setItem("reportID", item.report_id)
      this.$router.push(sessionStorage.getItem("portalRoute") + "/report")
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    handleEdit(item) {
      Swal.fire({
        title: `Edit ${item.mbr_firstName} ${item.mbr_lastName}\'s Report?`,
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-danger btn-fill"
      }).then((result) => {
        if (result.value) {
          this.updtScreeningStatus(item)
          Swal.fire({
            title: "Revived!",
            text: `${item.mbr_firstName} ${item.mbr_lastName}\'s Screening is in the On-Hold queue`,
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          }).then((result) => {
            if (result.value) {
              this.$router.push(`${sessionStorage.getItem('portalRoute')}/Onhold`)
            }
          })
        }
      })
    },
    async handleDownload() {
      if (!this.reportsSelected.length) return;

      this.isPreparing = true;
      this.isDownloading = false;
      this.downloadProgress = 0;

      await this.$nextTick();

      try {
        const response = await window.axios.post(
          `${this.API_SERVICE}/reports/download-bulk`,
          this.reportsSelected,
          {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              if (this.isPreparing) {
                this.isPreparing = false;
                this.isDownloading = true;
              }

              if (progressEvent.lengthComputable) {
                this.downloadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            }
          }
        );

        const blob = new Blob([response.data], { type: "application/zip" });
        const zipFileName = `downloaded_reports_${new Date().toISOString().split("T")[0]}.zip`;
        saveAs(blob, zipFileName);

        await window.axios.put(`${this.API_SERVICE}/report/mark-as-downloaded`, this.reportsSelected);
        this.reportsSelected.forEach((id) => {
          const all = [this.filteredReports, this.allReports, this.tableData];
          all.forEach((arr) => {
            const item = arr.find((i) => i.report_id === id);
            if (item) item.isDownloaded = true;
          });
        });

      } catch (error) {
        console.error("Erro no download:", error);
      } finally {
        this.isPreparing = false;
        this.isDownloading = false;
        this.downloadProgress = 0;
      }
    },


    updtScreeningStatus(i) {
      var vm = this
      var newStatus = "Edit"
      var screening = i.packageID
      var reader = sessionStorage.getItem("userID")

      const config = { headers: { "Content-Type": "application/json" } }
      const url = this.API_SERVICE + "/screening/" + screening + "/" + newStatus + "/" + reader //[screening-status]
      const data = null

      console.log("REVIVE :", url)
      window.axios
        .put(url, data, config)
        .then(function (response) {
          vm.status = response.data
          console.log("Revive Status: ", vm.status)
        })
        .catch(function (error) {
          vm.status = "An error occurred: " + error
          console.log(vm.status)
        })
    },
    startDotAnimation() {
      this.dots = '';
      this.dotInterval = setInterval(() => {
        this.dots = this.dots.length < 3 ? this.dots + '.' : '';
      }, 500);
    },
    stopDotAnimation() {
      clearInterval(this.dotInterval);
      this.dotInterval = null;
      this.dots = '';
    },
  },
  mounted() {
    this.fetchReports()
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  color: white;
}

.table-striped {
  tbody>tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody>tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;
}

// .md-icon {
//   margin-left: 24px !important;
// }

#headers {
  transition: none;
  background-color: #edf2f7 !important;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}

.isRead {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
}

.isEDIT {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
  background-color: #e6ffe6 !important;
}

.md-table-row.isEDIT:hover {
  background-color: #ccffcc !important;
  color: #000000 !important;
}

.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container span {
  margin: 0 15px;
}
</style>
